import React, { useState, useMemo, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as S from "./Header.styles";
import { IconType } from "react-icons";
import { FiMenu, FiUser, FiLogOut } from "react-icons/fi";
import notify from "devextreme/ui/notify";
import logoImg from "../../assets/img/infra-logo2.svg";

import { ReactComponent as cerrarDrawer } from "../../assets/icons/derecha.svg";
import { useMsal } from "@azure/msal-react";

// Interfaces
interface UserMenuItem {
  path: string;
  icon: IconType;
  name: string;
}

interface HeaderProps {
  isSidebarOpen: boolean;
  toggleSidebar: () => void;
}

interface UserData {
  user: {
    nombre: string;
    correo: string;
  };
  token: string;
}

// Datos del menú
const userMenuItems: UserMenuItem[] = [
  { path: "/usuario-profile", icon: FiUser, name: "Mi perfil" },
  { path: "/", icon: FiLogOut, name: "Cerrar Sesión" },
];

// Función auxiliar
const findCurrentRouteName = (path: string): string => {
  if (path.includes("/inicio")) return "Inicio";
  if (path.includes("/usuarios")) return "Usuario";
  if (path.includes("/reporte-acetileno")) return "Reporte";
  return "Inicio";
};

// Componente Header
const Header: React.FC<HeaderProps> = ({ isSidebarOpen, toggleSidebar }) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [userName, setUserName] = useState<string | null>(null);
  const { instance, accounts } = useMsal();
  const pageTitle = useMemo(
    () => findCurrentRouteName(location.pathname),
    [location.pathname]
  );

  const ToggleIcon = isSidebarOpen ? cerrarDrawer : FiMenu;
  console.log(pageTitle);
  useEffect(() => {
    const storedUserData = localStorage.getItem("userData");
    if (storedUserData) {
      try {
        const parsedData: UserData = JSON.parse(storedUserData);
        if (parsedData.user && parsedData.user.nombre) {
          setUserName(parsedData.user.nombre);
        }
      } catch (error) {
        console.error("Error al parsear los datos del usuario:", error);
      }
    }
  }, []);

  const handleLogout = async () => {
    try {
      const storedUser = localStorage.getItem("userData");
      const userData = storedUser ? JSON.parse(storedUser) : null;
      const password = userData?.user?.password;
      notify("Se cerró sesión con éxito.", "success", 1500);
      if (password === null) {
        await localStorage.clear();
        await sessionStorage.clear();

        await instance.logoutRedirect({
          account: accounts[0],
          postLogoutRedirectUri: process.env.MSAL_POST_LOGOUT_URI || "/",
        });
      } else if(password !== null){
        localStorage.clear();
        sessionStorage.clear();

        navigate("/", { replace: true });
      }
    } catch (err) {
      console.error("Error cerrando sesión:", err);
      window.open(
        "https://login.microsoftonline.com/common/oauth2/v2.0/logout",
        "_self"
      );
    }
  };

  // ✅ LÓGICA CORREGIDA Y CLAVE
  const handleMenuItemClick = (item: UserMenuItem) => {
    // Para depurar: muestra en la consola qué item se clickeó
    console.log("Item clickeado:", item);

    setDropdownOpen(false); // Cierra el dropdown

    if (item.name === "Cerrar Sesión") {
      // Si el nombre es "Cerrar Sesión", llama a la función de logout
      handleLogout();
    } else {
      // Para cualquier otro caso (como "Mi perfil"), navega a la ruta del item
      navigate(item.path);
    }
  };

  const getInitials = (name: string | null) => {
    if (!name) return "";
    return name
      .split(" ")
      .map((word) => word[0]?.toUpperCase() || "")
      .join("")
      .slice(0, 2);
  };
  const handleLogoClick = () => {
    navigate("/inicio"); // o "/" según tu routing
  };
  return (
    <S.HeaderContainer>
      <S.LeftSection>
        <S.MenuButton
          onClick={toggleSidebar}
          aria-label="Toggle Sidebar"
          isOpen={isSidebarOpen}
        >
          <ToggleIcon size={24} />
        </S.MenuButton>
        <S.Logo
          onClick={handleLogoClick} // 👈 ahora sí es una función sin args
          role="button"
          tabIndex={0}
          src={logoImg}
          alt="Logo Infra"
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") handleLogoClick();
          }}
        />
      </S.LeftSection>

      <S.RightSection>
        <S.UserProfileContainer>
          <S.UserProfileButton onClick={() => setDropdownOpen(!isDropdownOpen)}>
            <div className="avatar">{getInitials(userName)}</div>
            <span>{userName}</span>
          </S.UserProfileButton>

          <S.DropdownMenu isOpen={isDropdownOpen}>
            {userMenuItems.map((item) => (
              <button
                key={item.path}
                // Se asegura de llamar a la función correcta con los datos del item
                onClick={() => handleMenuItemClick(item)}
                style={{
                  background: "none",
                  border: "none",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  cursor: "pointer",
                  padding: "0.5rem 1rem",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                <item.icon size={18} />
                <span>{item.name}</span>
              </button>
            ))}
          </S.DropdownMenu>
        </S.UserProfileContainer>
      </S.RightSection>
    </S.HeaderContainer>
  );
};

export default Header;
